import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import AddBoxIcon from "@mui/icons-material/AddBox";
import PersonIcon from "@mui/icons-material/Person";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ReviewsIcon from "@mui/icons-material/Reviews";
import { useAuth } from "../../services/AuthContext";

const SidebarSection = ({ children, isOpen }) => (
  <div
    className={`overflow-hidden transition-max-height duration-500 ease-in-out ${
      isOpen ? "max-h-[500px]" : "max-h-0"
    }`}
  >
    {children}
  </div>
);

const DriverListItems = () => (
  <div className="space-y-1 bg-gray-200 px-4 rounded-md">
    <NavLink
      to="/Dashboard/Driver"
      state={{ role: "Driver" }}
      className="hover:text-sky-600 py-2 px-4  rounded-md flex items-center space-x-3"
    >
      <PeopleIcon />
      <span className="font-semibold text-md">All Driver</span>
    </NavLink>
    {/* <NavLink
      to="/Dashboard/addDriver"
      state={{ role: "Driver" }}
      className="hover:text-sky-600 py-2 px-4  rounded-md flex items-center space-x-3"
    >
      <AddBoxIcon />
      <span className="font-semibold text-md">Add Driver</span>
    </NavLink> */}
  </div>
);

const UserListItems = () => (
  <div className="space-y-1 bg-gray-200 px-4 rounded-md">
    <NavLink
      to="/Dashboard/Customer"
      state={{ role: "Customer" }}
      className="hover:text-sky-600 py-2 px-4  rounded-md flex items-center space-x-3"
    >
      <PeopleIcon />
      <span className="font-semibold text-md">All Customer</span>
    </NavLink>
  </div>
);

const ManagerListItems = () => (
  <div className="space-y-1 bg-gray-200 px-4 rounded-md">
    <NavLink
      to="/Dashboard/Manager"
      state={{ role: "Manager", role_id: 3 }}
      className="hover:text-sky-600 py-2 px-4  rounded-md flex items-center space-x-3"
    >
      <PeopleIcon />
      <span className="font-semibold text-md">All Manager</span>
    </NavLink>
    <NavLink
      to="/Dashboard/AddManager"
      state={{ role: "Manager", role_id: 3 }}
      className="hover:text-sky-600 py-2 px-4  rounded-md flex items-center space-x-3"
    >
      <AddBoxIcon />
      <span className="font-semibold text-md">Add Manager</span>
    </NavLink>
  </div>
);

const AdminListItems = () => (
  <div className="space-y-1 bg-gray-200 px-4 rounded-md">
    <NavLink
      to="/Dashboard/Admin"
      state={{ role: "Admin", role_id: 2 }}
      className="hover:text-sky-600 py-2 px-4  rounded-md flex items-center space-x-3"
    >
      <PeopleIcon />
      <span className="font-semibold text-md">All Admins</span>
    </NavLink>
    <NavLink
      to="/Dashboard/AddAdmin"
      state={{ role: "Admin", role_id: 2 }}
      className="hover:text-sky-600 py-2 px-4  rounded-md flex items-center space-x-3"
    >
      <AddBoxIcon />
      <span className="font-semibold text-md">Add Admin</span>
    </NavLink>
  </div>
);

const BookingListItems = () => (
  <div className="space-y-1 bg-gray-200 px-4 rounded-md">
    <NavLink
      to="/Dashboard/Allbooking"
      // state={{ role: "Admin", role_id: 2 }}
      className="hover:text-sky-600 py-2 px-4  rounded-md flex items-center space-x-3"
    >
      <LocalTaxiIcon />
      <span className="font-semibold text-md">All Booking</span>
    </NavLink>
  </div>
);

const WalletListItems = () => (
  <div className="space-y-1 bg-gray-200 px-4 rounded-md">
    <NavLink
      to="/Dashboard/AllWallet"
      // state={{ role: "Admin", role_id: 2 }}
      className="hover:text-sky-600 py-2 px-4  rounded-md flex items-center space-x-3"
    >
      <AccountBalanceWalletIcon />
      <span className="font-semibold text-md">Wallet Top-Ups</span>
    </NavLink>
    <NavLink
      to="/Dashboard/AllWallet"
      state={{ role: "Driver" }}
      className="hover:text-sky-600 py-2 px-4  rounded-md flex items-center space-x-3"
    >
      <AccountBalanceWalletIcon />
      <span className="font-semibold text-md">Driver Wallet Report</span>
    </NavLink>
  </div>
);

const Sidebar = () => {
  const [openAdmin, setAdmin] = useState(false);
  const [openManager, setManager] = useState(false);
  const [openMain, setOpenMain] = useState(false);
  const [openSecondary, setOpenSecondary] = useState(false);
  const [openBooking, setOpenBooking] = useState(false);
  const [openWallet, setOpenWallet] = useState(false);
  const { user } = useAuth();
  const role_id = user?.role_id;
  const nav = useNavigate();

  const handleWalletClick = () => {
    setOpenWallet((prev) => !prev);
    if (openWallet) setOpenWallet(false);
  };

  const handleBookClick = () => {
    setOpenBooking((prev) => !prev);
    if (openBooking) setOpenBooking(false);
  };

  const handleMainClick = () => {
    setOpenMain((prev) => !prev);
    if (openSecondary) setOpenSecondary(false);
  };

  const handleSecondaryClick = () => {
    setOpenSecondary((prev) => !prev);
    if (openMain) setOpenMain(false);
  };

  const handleManagerClick = () => {
    setManager((prev) => !prev);
    if (openAdmin) setAdmin(false);
  };

  const handleAdminClick = () => {
    setAdmin((prev) => !prev);
    if (openManager) setManager(false);
  };

  if (!user) return null; // Render nothing if no user data

  return (
    <div className="text-sky-900 w-64 space-y-4">
      {/* Dashboard */}
      <div
        onClick={() => nav("/Dashboard")}
        className="flex items-center font-bold  text-lg hover:text-sky-900 py-2 px-4 rounded-md cursor-pointer"
      >
        <DashboardIcon />
        <span className="ml-5">Dashboard</span>
      </div>

      {role_id === 1 && (
        <>
          {/* Admin */}
          <div
            className="flex items-center justify-between font-bold text-md px-4 hover:text-sky-900 cursor-pointer"
            onClick={handleAdminClick}
          >
            <div className="flex items-center space-x-5">
              <PersonIcon />
              <span>Admin</span>
            </div>
            {openAdmin ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
          {openAdmin && (
            <SidebarSection isOpen={openAdmin}>
              <AdminListItems />
            </SidebarSection>
          )}

          {/* Manager */}
          <div
            className="flex items-center justify-between font-bold text-md py-2 px-4 hover:text-sky-900 cursor-pointer"
            onClick={handleManagerClick}
          >
            <div className="flex items-center space-x-5">
              <PeopleIcon />
              <span className="ml-5">Manager</span>
            </div>
            {openManager ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
          {openManager && (
            <SidebarSection isOpen={openManager}>
              <ManagerListItems />
            </SidebarSection>
          )}

          {/* Drivers */}
          <div
            className="flex items-center justify-between font-bold text-md py-2 px-4 hover:text-sky-900 cursor-pointer"
            onClick={handleMainClick}
          >
            <div className="flex items-center space-x-5">
              <PeopleIcon />
              <span className="ml-5">Drivers</span>
            </div>
            {openMain ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
          {openMain && (
            <SidebarSection isOpen={openMain}>
              <DriverListItems />
            </SidebarSection>
          )}

          {/* Customers */}
          <div
            className="flex items-center justify-between font-bold text-md py-2 px-4 hover:text-sky-900 cursor-pointer"
            onClick={handleSecondaryClick}
          >
            <div className="flex items-center space-x-5">
              <PeopleIcon />
              <span className="ml-5">Customers</span>
            </div>
            {openSecondary ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
          {openSecondary && (
            <SidebarSection isOpen={openSecondary}>
              <UserListItems />
            </SidebarSection>
          )}
        </>
      )}

      {/* Role Based UI for other role_id */}
      {role_id === 2 && (
        <>
          {/* Manager */}
          <div
            className="flex items-center justify-between font-bold text-md py-2 px-4 hover:text-sky-900 cursor-pointer"
            onClick={handleManagerClick}
          >
            <div className="flex items-center space-x-5">
              <PeopleIcon />
              <span className="ml-5">Manager</span>
            </div>
            {openManager ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
          {openManager && (
            <SidebarSection isOpen={openManager}>
              <ManagerListItems />
            </SidebarSection>
          )}

          {/* Drivers */}
          <div
            className="flex items-center justify-between font-bold text-md py-2 px-4 hover:text-sky-900 cursor-pointer"
            onClick={handleMainClick}
          >
            <div className="flex items-center space-x-5">
              <PeopleIcon />
              <span className="ml-5">Drivers</span>
            </div>
            {openMain ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
          {openMain && (
            <SidebarSection isOpen={openMain}>
              <DriverListItems />
            </SidebarSection>
          )}

          {/* Customers */}
          <div
            className="flex items-center justify-between font-bold text-md py-2 px-4 hover:text-sky-900 cursor-pointer"
            onClick={handleSecondaryClick}
          >
            <div className="flex items-center space-x-5">
              <PeopleIcon />
              <span className="ml-5">Customers</span>
            </div>
            {openSecondary ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
          {openSecondary && (
            <SidebarSection isOpen={openSecondary}>
              <UserListItems />
            </SidebarSection>
          )}
        </>
      )}

      {role_id === 3 && (
        <>
          {/* Drivers */}
          <div
            className="flex items-center justify-between font-bold text-md py-2 px-4 hover:text-sky-900 cursor-pointer"
            onClick={handleMainClick}
          >
            <div className="flex items-center space-x-5">
              <PeopleIcon />
              <span className="ml-5">Drivers</span>
            </div>
            {openMain ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
          {openMain && (
            <SidebarSection isOpen={openMain}>
              <DriverListItems />
            </SidebarSection>
          )}

          {/* Customers */}
          <div
            className="flex items-center justify-between font-bold text-md py-2 px-4 hover:text-sky-900 cursor-pointer"
            onClick={handleSecondaryClick}
          >
            <div className="flex items-center space-x-5">
              <PeopleIcon />
              <span className="ml-5">Customers</span>
            </div>
            {openSecondary ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
          {openSecondary && (
            <SidebarSection isOpen={openSecondary}>
              <UserListItems />
            </SidebarSection>
          )}
        </>
      )}

      <div
        className="flex items-center justify-between font-bold text-md py-2 px-4 hover:text-sky-900 cursor-pointer"
        onClick={handleBookClick}
      >
        <div className="flex items-center space-x-5">
          <LocalTaxiIcon />
          <span className="ml-5">All Booking</span>
        </div>
        {openBooking ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </div>
      {openBooking && (
        <SidebarSection isOpen={openBooking}>
          <BookingListItems />
        </SidebarSection>
      )}
      <div
        className="flex items-center justify-between font-bold text-md py-2 px-4 hover:text-sky-900 cursor-pointer"
        onClick={handleWalletClick}
      >
        <div className="flex items-center space-x-5">
          <AccountBalanceWalletIcon />
          <span className="ml-5">Wallet Report</span>
        </div>
        {openWallet ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </div>
      {openWallet && (
        <SidebarSection isOpen={openWallet}>
          <WalletListItems />
        </SidebarSection>
      )}

      <div
        onClick={() => nav("/Dashboard/AllReviews")}
        className="flex items-center font-bold  text-md hover:text-sky-900 py-2 px-4 rounded-md cursor-pointer"
      >
        <ReviewsIcon />
        <span className="ml-5">Rating & Reviews</span>
      </div>
    </div>
  );
};

export default Sidebar;
